import { render, staticRenderFns } from "./UnderAnalysisApplications.vue?vue&type=template&id=a0bdfcb4&"
import script from "./UnderAnalysisApplications.vue?vue&type=script&lang=js&"
export * from "./UnderAnalysisApplications.vue?vue&type=script&lang=js&"
import style0 from "./UnderAnalysisApplications.vue?vue&type=style&index=0&id=a0bdfcb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports